import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const InventoryHero = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ padding: 3 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/demo/dashboard")}
        sx={{ marginBottom: 3 }}
      >
        Back
      </Button>
      <Typography variant="h4" align="center" gutterBottom>
        Inventory Management
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginBottom: 4,
          gap: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={() => navigate("/demo/inventory")}
        >
          Inventory
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/demo/inventory/archive")}
        >
          Archive
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/demo/inventory/history")}
        >
          History
        </Button>
      </Box>
    </Box>
  );
};

export default InventoryHero;
